import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import AppContext from "../AppContext";
import { hasLoggedInStaffProfile } from "../services/Utils";

const Dashboard = () => {
  const global = useContext(AppContext);
  const history = useHistory();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loggedInUser = global.get_logged_in_user();
    if (loggedInUser) {
      setUser(loggedInUser);
    }
  }, [global]);

  const hasStaffInfo = hasLoggedInStaffProfile(user);

  const handleNavigate = (path) => {
    history.push(path);
  };

  const quickActions = [
    {
      title: 'Ongoing Surveys',
      icon: '📋',
      path: '/ebms/surveys/ongoing',
      color: '#667eea',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      description: 'View and manage ongoing surveys'
    },
    ...(hasStaffInfo ? [
      {
        title: 'My Leave Requests',
        icon: '📅',
        path: '/hrm/leave/my-leave-requests',
        color: '#f093fb',
        gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        description: 'Manage your leave requests'
      },
      {
        title: 'My Payslips',
        icon: '💰',
        path: '/hrm/payslips',
        color: '#fa709a',
        gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
        description: 'View and download your payslip history'
      }
    ] : [])
  ];

  return (
    <div style={{
      minHeight: 'calc(100vh - 200px)',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      padding: '30px 20px'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {/* Header Section */}
        <div style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '20px',
          padding: '40px',
          marginBottom: '30px',
          boxShadow: '0 10px 40px rgba(102, 126, 234, 0.3)',
          color: '#fff',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: '-50px',
            right: '-50px',
            width: '200px',
            height: '200px',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '50%'
          }}></div>
          <div style={{
            position: 'absolute',
            bottom: '-30px',
            left: '-30px',
            width: '150px',
            height: '150px',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '50%'
          }}></div>
          
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{
              fontSize: '56px',
              marginBottom: '15px',
              display: 'inline-block'
            }}>
              👋
            </div>
            <h1 style={{
              fontSize: '42px',
              fontWeight: 'bold',
              margin: '0 0 10px 0',
              textShadow: '0 2px 10px rgba(0,0,0,0.2)'
            }}>
              Welcome to EBMS Dashboard
            </h1>
            {user?.name && (
              <p style={{
                fontSize: '20px',
                margin: '0 0 15px 0',
                opacity: 0.95,
                color: 'white'
              }}>
                Hello, < span style={{ color: 'white' }}>{user.name}</span>!
              </p>
            )}
            {user?.email && (
              <p style={{
                fontSize: '16px',
                margin: '0 0 20px 0',
                opacity: 0.9
              }}>
                {user.email}
              </p>
            )}
            {user?.role_name && (
              <div style={{
                display: 'inline-block',
                padding: '10px 20px',
                backgroundColor: 'rgba(255, 255, 255, 0.25)',
                backdropFilter: 'blur(10px)',
                borderRadius: '25px',
                fontSize: '15px',
                fontWeight: '600',
                border: '1px solid rgba(255, 255, 255, 0.3)'
              }}>
                {user.role_name}
              </div>
            )}
          </div>
        </div>

        {/* Quick Actions Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '25px',
          marginBottom: '30px'
        }}>
          {quickActions.map((action, index) => (
            <div
              key={index}
              onClick={() => handleNavigate(action.path)}
              style={{
                background: '#fff',
                borderRadius: '16px',
                padding: '30px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                border: '1px solid #e0e0e0',
                position: 'relative',
                overflow: 'hidden'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.1)';
              }}
            >
              {/* Gradient Accent */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '5px',
                background: action.gradient
              }}></div>
              
              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '20px'
              }}>
                <div style={{
                  fontSize: '48px',
                  lineHeight: '1'
                }}>
                  {action.icon}
                </div>
                <div style={{ flex: 1 }}>
                  <h3 style={{
                    fontSize: '22px',
                    fontWeight: 'bold',
                    color: '#333',
                    margin: '0 0 8px 0'
                  }}>
                    {action.title}
                  </h3>
                  <p style={{
                    fontSize: '14px',
                    color: '#666',
                    margin: '0 0 15px 0',
                    lineHeight: '1.5'
                  }}>
                    {action.description}
                  </p>
                  <div style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    color: action.color,
                    fontSize: '14px',
                    fontWeight: '600',
                    marginTop: '10px'
                  }}>
                    <span>Go to {action.title}</span>
                    <span>→</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Info Cards Section */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '20px'
        }}>
          <div style={{
            background: '#fff',
            borderRadius: '16px',
            padding: '25px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            border: '1px solid #e0e0e0'
          }}>
            <div style={{
              fontSize: '32px',
              marginBottom: '10px'
            }}>🎯</div>
            <h4 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#333',
              margin: '0 0 5px 0'
            }}>Quick Access</h4>
            <p style={{
              fontSize: '13px',
              color: '#666',
              margin: 0
            }}>Navigate to your most used features</p>
          </div>

          <div style={{
            background: '#fff',
            borderRadius: '16px',
            padding: '25px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            border: '1px solid #e0e0e0'
          }}>
            <div style={{
              fontSize: '32px',
              marginBottom: '10px'
            }}>📊</div>
            <h4 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#333',
              margin: '0 0 5px 0'
            }}>Dashboard</h4>
            <p style={{
              fontSize: '13px',
              color: '#666',
              margin: 0
            }}>Your central hub for all activities</p>
          </div>

          <div style={{
            background: '#fff',
            borderRadius: '16px',
            padding: '25px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            border: '1px solid #e0e0e0'
          }}>
            <div style={{
              fontSize: '32px',
              marginBottom: '10px'
            }}>⚡</div>
            <h4 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#333',
              margin: '0 0 5px 0'
            }}>Stay Updated</h4>
            <p style={{
              fontSize: '13px',
              color: '#666',
              margin: 0
            }}>Get the latest information at a glance</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

